module.exports = __webpack_public_path__ + "img/w5.2b16c9e0.webp";